import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';
import { call, select, takeLatest } from 'redux-saga/effects';
import { fetchQuery } from 'relay-runtime';
import { createAsyncAction, getType } from 'typesafe-actions';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import { selectAuthUser } from '@lib/selectors';
import environment from '@lib/utils/RelayEnvironment';

import { ON_SOCKET_USER_UPDATE } from 'containers/App/constants';

export const actionUpdateViewer = createAsyncAction(
  'actionUpdateViewer/REQUEST',
  'actionUpdateViewer/SUCCESS',
  'actionUpdateViewer/FAILURE',
)<any, any, any>();

export const actionSaveFilters = createAsyncAction(
  'actionSaveFilters/REQUEST',
  'actionSaveFilters/SUCCESS',
  'actionSaveFilters/FAILURE',
)<any, any, any>();

export const actionViewerFavorite = createAsyncAction(
  'actionViewerFavorite/REQUEST',
  'actionViewerFavortie/SUCCESS',
  'actionViewerFavorite/FAILURE',
)<any, any, any>();

export const actionViewerRecentlyUsed = createAsyncAction(
  'actionViewerRecentlyUsed/REQUEST',
  'actionViewerRecentlyUsed/SUCCESS',
  'actionViewerRecentlyUsed/FAILURE',
)<any, any, any>();

const query = graphql`
  query sagaWatchersViewerQuery {
    viewer {
      # TODO reuse fragment from WrapperQueryListChatActivities once its refactored
      roles
      firstname
      lastname
      oid_groups
      active
      filters
      recentlyUsedSettings
      filters
      displayStatus
      oid_avatar
      displayPhone
      salesforceData {
        provisioning
      }
      user {
        settings
      }
      setting {
        settings {
          communication {
            unsubscribedMessages
          }
        }
      }
    }
  }
`;

function* sagaWatcherUpdateViewer(action: any) {
  try {
    // Add `forceFetchQuery` if you want to fetch manually and not wait for the socket event to
    // fetch and update the store.
    const forceFetchQuery = get(
      action,
      'payload.requestPayload.forceFetchQuery',
      get(action, 'payload.forceFetchQuery', true),
    );
    if (forceFetchQuery) yield call(fetchQuery, environment, query, {});
  } catch (error) {
    sendLog('sagaWatchersViewer#sagaWatcherUpdateViewer', { error }, LoggerStatusEnum.error);
  }
}

export function* sagaWatcher(action: any) {
  try {
    const _id = get(action, 'data');
    if (!_id) {
      sendLog('sagaWatchersViewer#sagaWatcher _id not found', { action }, LoggerStatusEnum.warn);
      return;
    }
    const viewerId: string = yield select(selectAuthUser);
    if (_id === viewerId) {
      yield call(fetchQuery, environment, query, {});
    }
  } catch (error) {
    sendLog('sagaWatchersViewer#sagaWatcher', { error, action }, LoggerStatusEnum.error);
  }
}

export default function* sagaWatchersViewer() {
  yield takeLatest(ON_SOCKET_USER_UPDATE, sagaWatcher);
  yield takeLatest(getType(actionSaveFilters.success), sagaWatcherUpdateViewer);
  yield takeLatest(getType(actionUpdateViewer.success), sagaWatcherUpdateViewer);
}
